// 1 dòng lưới = 1 môn của CTĐT + đơn giá pivot 6 tính chất học.
export interface IMucHocPhiTheoCTDTMon {
  id_dt: number;
  id_mon: number;
  ky_hieu: string;
  ten_mon: string;
  ky_thu: number;
  so_tin_chi: number;
  stt_mon: number;

  id_hoc_di: number | null;
  so_tien_hoc_di: number | null;
  id_hoc_lai: number | null;
  so_tien_hoc_lai: number | null;
  id_hoc_cai_thien: number | null;
  so_tien_hoc_cai_thien: number | null;
  id_hoc_bu: number | null;
  so_tien_hoc_bu: number | null;
  id_hoc_vuot: number | null;
  so_tien_hoc_vuot: number | null;
  id_hoc_ngoai_ct: number | null;
  so_tien_hoc_ngoai_ct: number | null;

  locked: boolean;
  [x: string]: any;
}

// 1 CTĐT cho combobox chọn Chương trình đào tạo.
export interface IMucHocPhiTheoCTDTCTDT {
  id_dt: number;
  id_he: number;
  khoa_hoc: number;
  id_nganh: number;
  id_chuyen_nganh: number;
  id_khoi_nganh: number;
  ky_hieu_ctdt: string | null;
  ma_khung: string | null;
  nien_khoa_ctdt: string | null;
  ten_he: string;
  ten_nganh: string;
  ma_nganh: string;
  chuyen_nganh: string;
}

// Dòng đơn giá gửi lên save (khớp Model.Table.dmMucHocPhiTheoCTDT ở BE).
export interface IMucHocPhiTheoCTDT {
  id: number;
  hoc_ky: number;
  nam_hoc: string;
  ky_dang_ky: number;
  id_dt: number;
  id_mon: number;
  id_he: number;
  khoa_hoc: number;
  id_nganh: number;
  id_chuyen_nganh: number;
  id_khoi_nganh: number;
  id_doi_tuong: number;
  dot_tuyen_sinh: number;
  hoc_lai: number;
  tinh_chat: string;
  so_tien: number;
  locked?: boolean;
}

// 6 tính chất học -> (hoc_lai code, tên field pivot id_<key>/so_tien_<key>, nhãn cột).
export const CTDT_TINH_CHATS: { hoc_lai: number; key: string; label: string }[] =
  [
    { hoc_lai: 0, key: "hoc_di", label: "Học đi" },
    { hoc_lai: 1, key: "hoc_lai", label: "Học lại" },
    { hoc_lai: 2, key: "hoc_cai_thien", label: "Cải thiện" },
    { hoc_lai: 3, key: "hoc_bu", label: "Học bù" },
    { hoc_lai: 4, key: "hoc_vuot", label: "Học vượt" },
    { hoc_lai: 5, key: "hoc_ngoai_ct", label: "Ngoài CT" },
  ];

// Map id_dt -> nhãn "Hệ · Khóa · Chuyên ngành · Chương trình {số}{(mã khung)}".
// Số thứ tự ổn định trong nhóm (hệ, khóa, chuyên ngành) -> phân biệt các CTĐT trùng thiếu mã khung.
export const buildCtdtLabelMap = (
  ctdts: IMucHocPhiTheoCTDTCTDT[],
): Map<number, string> => {
  const sorted = [...ctdts].sort(
    (a, b) =>
      (a.id_he ?? 0) - (b.id_he ?? 0) ||
      (a.khoa_hoc ?? 0) - (b.khoa_hoc ?? 0) ||
      (a.id_chuyen_nganh ?? 0) - (b.id_chuyen_nganh ?? 0) ||
      (a.id_dt ?? 0) - (b.id_dt ?? 0),
  );
  const ord = new Map<string, number>();
  const map = new Map<number, string>();
  for (const c of sorted) {
    const cnKey = `${c.id_he ?? 0}-${c.khoa_hoc ?? 0}-${c.id_chuyen_nganh ?? 0}`;
    const so = (ord.get(cnKey) ?? 0) + 1;
    ord.set(cnKey, so);
    const ma = (c.ma_khung || c.ky_hieu_ctdt || "").toString().trim();
    const he = c.ten_he || `Hệ ${c.id_he ?? 0}`;
    const cn =
      c.chuyen_nganh || c.ten_nganh || `Chuyên ngành ${c.id_chuyen_nganh ?? 0}`;
    map.set(
      c.id_dt,
      `${he} · Khóa ${c.khoa_hoc} · ${cn} · Chương trình ${so}${ma ? ` (${ma})` : ""}`,
    );
  }
  return map;
};

// Nhãn hiển thị 1 CTĐT trên combobox.
export const buildCtdtLabel = (c: IMucHocPhiTheoCTDTCTDT): string => {
  const parts = [
    c.ten_he,
    c.chuyen_nganh || c.ten_nganh,
    c.khoa_hoc ? `Khóa ${c.khoa_hoc}` : "",
    c.ky_hieu_ctdt || c.ma_khung || "",
  ].filter((x) => x && x.toString().trim() !== "");
  return parts.join(" - ");
};
